import { render, staticRenderFns } from "./ServiceRepairDashboard.vue?vue&type=template&id=4c7579a0&"
import script from "./ServiceRepairDashboard.vue?vue&type=script&lang=js&"
export * from "./ServiceRepairDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports